var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 72,
    viewBox: "0 0 96 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H48.216V16.749H0Z",
    transform: "translate(44.595 53.605) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.851-2.091l-.04,20.61-51.841.1.04-20.61Zm-4.02,16.63L45.855,1.9,1.99,1.99,1.965,14.624Z",
    transform: "translate(45.045 53.697) rotate(-45)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H96V72H0Z",
    transform: "translate(-1 -1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.534,85.225,60.691,73.382,57.606,88.31Z",
    transform: "translate(-15.694 -19.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.606,90.22a1.994,1.994,0,0,1-1.953-2.4L58.709,72.98a1.994,1.994,0,0,1,3.366-1.005L73.805,83.752a1.994,1.994,0,0,1-1.008,3.36L58.011,90.179A1.994,1.994,0,0,1,57.606,90.22Zm4.261-12.8-1.7,8.24,8.209-1.7Z",
    transform: "translate(-15.617 -19.685)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H92V70H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.843,13.837a1.988,1.988,0,0,1-1.41-.584L-1.41,1.41a1.994,1.994,0,0,1,0-2.82,1.994,1.994,0,0,1,2.82,0L13.253,10.433a1.994,1.994,0,0,1-1.41,3.4Z",
    transform: "translate(72.987 25.435)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,30.386A1.988,1.988,0,0,1-1.41,29.8a1.994,1.994,0,0,1,0-2.82L26.982-1.41a1.994,1.994,0,0,1,2.82,0,1.994,1.994,0,0,1,0,2.82L1.41,29.8A1.988,1.988,0,0,1,0,30.386Z",
    transform: "translate(50.517 31.134)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.555,1.994H0V-1.994H25.555Z",
    transform: "translate(6.882 56.283)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.388,1.994H0V-1.994H35.388Z",
    transform: "translate(6.601 68.541)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.219,11.842c6.336.964,9.694,4.22,10.422,11.842.644-7.546,3.849-10.878,10.422-11.842C58.491,10.878,55.286,7.546,54.641,0c-.729,7.622-4.087,10.878-10.422,11.842",
    transform: "translate(-11.988 0)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,42.867c5.6.852,8.574,3.732,9.218,10.474.57-6.674,3.405-9.622,9.219-10.474-5.814-.852-8.649-3.8-9.219-10.474C8.574,39.135,5.6,42.015,0,42.867",
    transform: "translate(0 -8.69)",
    fill: "#195ace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H92V70H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e083257bc411d69c441af2aa15f3341f.svg";
export { ForwardRef as ReactComponent };